import { css } from '@emotion/core';
const baseStyle = (theme, active, isClickable) => css`
  background-color: ${active
    ? theme?.vds?.secondary || '#003ea9'
    : theme?.vds?.actionSecondary || '#fff'} !important;

  color: ${active
   ? theme?.vds?.actionSecondary || '#fff':
     theme?.vds?.notificationForegroundDark || '#222'} !important;

  ${active
    ? theme?.classes?.typography?.color?.misc?.white || 'color: rgba(255,255,255,1);'
    : theme?.classes?.typography?.color?.misc?.medium || 'color: rgba(118,118,118,1);'}

  &:not(.vds-state--focus) {
    outline: none !important;

    & [class^='vds-btn-icon'] {
      outline: none !important;
    }
  }

  &.vds-state--focus {
    background-color: ${theme?.vds?.buttonSecondaryTextBackgroundFocus ||
    '#e0eafa'};

    ${isClickable
      ? `outline: 1px dashed ${theme?.vds?.focusOutlineColor || '#15195a'};`
      : ''}

    outline-offset: 0;

    & [class^='vds-btn-icon'] {
      outline: none !important;
    }
  }
`;

const styles = (theme, active, isClickable) => ({
  columnFilter: css`
    ${baseStyle(theme, active, isClickable)};
    height: 2.5rem;
    &.vds-chip {
      border-radius: 0rem !important;
      width: 100%;
      justify-content: space-between;
      margin: 0 !important;

      &.vds-btn-icon {
        justify-self: flex-end;
      }
    }
  `,
  chipActive: baseStyle(theme, active, isClickable)
});

export default styles;
